import React, { useEffect, useState } from "react";
import { ApiClient } from "../../utils/api-client";
import Header from "../home/header";
import PaginationControl from "../home/pagination_control";
import { useNavigate } from "react-router-dom";
import Loading from "../home/Loading";
import TenderItem from "./tender_item"

const Tenders = () => {

    const navigate = useNavigate();
    const loginState = sessionStorage.getItem( 'loginState' ) ? JSON.parse( sessionStorage.getItem( "loginState" ) ) : null;
    const apiClient = new ApiClient( loginState?.accessToken )

    const [ tenders, setTenders ] = useState( [] )
    const [ filteredTenders, setFilteredTenders ] = useState( tenders );
    const [ loading, setLoading ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ pageSize, setPageSize ] = useState( 10 );
    const [ totalPages, setTotalPages ] = useState( 1 );
    const [ hasNextPage, setHasNextPage ] = useState( false );
    const [ hasPreviousPage, setHasPreviousPage ] = useState( false );


    const handlePageChange = ( page ) => {
        loadData( page, pageSize );
    }
    const handlePageSizeChange = ( pageSize ) => {
        loadData( 1, pageSize );
    }

    const loadData = async ( page = currentPage, limit = pageSize ) => {
        setLoading( true );
        const req = await apiClient.get( "tenders", { params: { page, limit } } );
        if ( req.status === 200 && req.data ) {
            setTenders( req.data.data );
            setFilteredTenders( req.data.data );
            setTotalPages( req.data.totalPages );
            setCurrentPage( req.data.page );
            setHasNextPage( req.data.hasNextPage );
            setHasPreviousPage( req.data.hasPreviousPage );
            setPageSize( req.data.limit );
        }
        setLoading( false );
    }
    useEffect( () => {
        loadData();
    }, [] )

    return <>
        <Header auth={loginState} />
        <section className="flex justify-start items-start">
            <div className="container">
                <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div>
                            <p className="text-sm uppercase tracking-wide text-gray-500">Projects</p>
                            <p className="text-2xl font-semibold text-gray-800">Tenders</p>
                        </div>
                        <div className="w-full md:w-auto flex flex-col md:flex-row gap-3">
                            <input className="w-full md:w-80 px-3 py-2 focus:outline-none rounded-md border border-gray-300 focus:ring-2 focus:ring-gray-300" type="text" placeholder="Search tenders..."
                                onChange={( e ) => {
                                    const keyword = e.target.value.toLowerCase();
                                    const filtered = tenders.filter( p =>
                                        ( p?.title || '' ).toLowerCase().includes( keyword ) ||
                                        ( p?.client || '' ).toLowerCase().includes( keyword ) ||
                                        String( p?.status || '' ).toLowerCase().includes( keyword )
                                    );
                                    setFilteredTenders( filtered );
                                }}
                            />
                            <button className="btn bg-success md:min-w-[7rem]" onClick={() => navigate( "/tenders/new", { replace: false } )}>Add Tender</button>
                        </div>
                    </div>
                </div>
                {loading ? ( <Loading className="mx-auto mt-16" /> ) : (
                    <div className="mt-12">{filteredTenders.length > 0 ? <PaginationControl pageSize={pageSize} currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} /> : null}
                        <div className="border border-gray-200 rounded-lg overflow-hidden pt-0 grid md:grid-cols-1 gap-0 md:justify-start md:items-center flex-wrap" id="list_container">
                            <div className="grid md:grid-cols-6 bg-gray-100 p-3 font-semibold text-gray-700 ">
                                <span>Date</span>
                                <span>Title</span>
                                <span>Client</span>
                                <span>Tender Amount</span>
                                <span>Amount Spent</span>
                                <span>Status</span>
                            </div>
                            {filteredTenders.length > 0 ? (
                                filteredTenders.map( ( tender, idx ) => (
                                    <TenderItem key={idx} tender={tender} />
                                ) )
                            ) : ( <p className="text-center col-span-5 py-8 text-gray-500">No tenders found</p> )}
                        </div>
                    </div>
                )}</div>
        </section>
    </>
}
export default Tenders;

